// This function uploads a file to S3 using a presigned URL.
// You need an API endpoint (e.g. /api/upload-url) that returns a presigned URL for a given file name and type.
// The function returns the final S3 URL upon success.

export async function uploadImageToS3(file) {
    // Create FormData for multipart/form-data upload
    const formData = new FormData();
    const fileName = `${Date.now()}-${file.name}`; // Unique file name
    
    formData.append('file', file);
    formData.append('file_name', fileName);

    // Upload directly to backend
    const uploadRes = await fetch('https://vitaldev.vitalinsights.in/user/upload-file-to-s3', {
        method: 'POST',
        body: formData,
        // Note: Don't set Content-Type header, browser will set it automatically with boundary
    });

    if (!uploadRes.ok) throw new Error('Failed to upload file');
    
    const response = await uploadRes.json();
    if (!response.fileUrl) throw new Error('Invalid response from server');

    return response.fileUrl;
}